import { defineMessages } from 'react-intl'

import { FEATURES, PERMISSIONS } from './constants'

export const featureMessages = defineMessages({
  [FEATURES.COMPANY]: {
    id: 'dictionary.company',
    defaultMessage: 'Company'
  },
  [FEATURES.COMPANY_LINE]: {
    id: 'dictionary.companyLine',
    defaultMessage: 'Line'
  },
  [FEATURES.PLACE]: {
    id: 'dictionary.place',
    defaultMessage: 'Place'
  },
  [FEATURES.ROUTE]: {
    id: 'dictionary.route',
    defaultMessage: 'Route'
  },
  [FEATURES.SERVICE]: {
    id: 'dictionary.routeService',
    defaultMessage: 'Service'
  },
  [FEATURES.SEGMENT]: {
    id: 'dictionary.segment',
    defaultMessage: 'Segment'
  },
  [FEATURES.TRIP]: {
    id: 'dictionary.trip',
    defaultMessage: 'Trip'
  },
  [FEATURES.BOOKING]: {
    id: 'dictionary.booking',
    defaultMessage: 'Booking'
  },
  [FEATURES.SEAT]: {
    id: 'dictionary.seat',
    defaultMessage: 'Seat'
  },
  [FEATURES.PAYMENT]: {
    id: 'dictionary.payment',
    defaultMessage: 'Payment'
  },
  [FEATURES.EMAIL]: {
    id: 'dictionary.email',
    defaultMessage: 'Email'
  },
  [FEATURES.USER]: {
    id: 'dictionary.user',
    defaultMessage: 'User'
  },
  [FEATURES.POLICY]: {
    id: 'dictionary.policy',
    defaultMessage: 'Policy'
  },
  [FEATURES.SITE]: {
    id: 'dictionary.site',
    defaultMessage: 'Site'
  },
  [FEATURES.VEHICLE]: {
    id: 'dictionary.vehicle',
    defaultMessage: 'Vehicle'
  },
  [FEATURES.VEHICLE_TEMPLATE]: {
    id: 'dictionary.vehicleTemplate',
    defaultMessage: 'Vehicle template'
  },
  [FEATURES.BOOKING_CLASS]: {
    id: 'dictionary.bookingClass',
    defaultMessage: 'Booking class'
  },
  [FEATURES.SEASON_EVENT]: {
    id: 'dictionary.seasonEvent',
    defaultMessage: 'Season event'
  },
  [FEATURES.FARE_FAMILY]: {
    id: 'dictionary.fareFamily',
    defaultMessage: 'Fare family'
  },
  [FEATURES.CAMPAIGN]: {
    id: 'dictionary.campaign',
    defaultMessage: 'Campaign'
  },
  [FEATURES.COUPON]: {
    id: 'dictionary.coupon',
    defaultMessage: 'Coupon'
  },
  [FEATURES.REPORT]: {
    id: 'dictionary.report',
    defaultMessage: 'Report'
  },
  [FEATURES.CHANGES]: {
    id: 'dictionary.changes',
    defaultMessage: 'Changes'
  },
  [FEATURES.PASSENGER_TYPES]: {
    id: 'dictionary.passengerTypes',
    defaultMessage: 'Passenger Types'
  },
  [FEATURES.PASSENGER_PROPERTIES]: {
    id: 'dictionary.passengerTypes',
    defaultMessage: 'Passenger Properties'
  },
  [FEATURES.SCHEDULER]: {
    id: 'dictionary.scheduler',
    defaultMessage: 'Scheduler'
  },
  [FEATURES.DASHBOARD]: {
    id: 'dictionary.dashboard',
    defaultMessage: 'Dashboard'
  },
  [FEATURES.ITEM]: {
    id: 'dictionary.item',
    defaultMessage: 'Item'
  },
  [FEATURES.INVENTORY]: {
    id: 'dictionary.inventory',
    defaultMessage: 'Inventory'
  },
  [FEATURES.WAREHOUSE]: {
    id: 'dictionary.warehouse',
    defaultMessage: 'Warehouse'
  },
  [FEATURES.BASE]: {
    id: 'inventory.base.label',
    defaultMessage: 'Base'
  },
  [FEATURES.CART]: {
    id: 'inventory.cart.label',
    defaultMessage: 'Cart'
  },
  [FEATURES.ORDER]: {
    id: 'dictionary.order',
    defaultMessage: 'Order'
  },
  [FEATURES.SALE]: {
    id: 'dictionary.sale',
    defaultMessage: 'Sale'
  },
  [FEATURES.PASSENGERS]: {
    id: 'dictionary.passengers',
    defaultMessage: 'Passengers'
  },
  [FEATURES.FARE_RULE]: {
    id: 'dictionary.fareRule',
    defaultMessage: 'Fare Rule'
  },
  [FEATURES.INVENTORY_RULE]: {
    id: 'dictionary.inventoryRule',
    defaultMessage: 'Inventory Rule'
  },
  [FEATURES.WALLET]: {
    id: 'dictionary.wallet',
    defaultMessage: 'Wallet'
  },
  [FEATURES.KREDIT]: {
    id: 'dictionary.kredit',
    defaultMessage: 'Kredit'
  },
  [FEATURES.BUSINESS_SITE]: {
    id: 'dictionary.businessSite',
    defaultMessage: 'Business Site'
  },
  [FEATURES.BUSINESS_CLIENT]: {
    id: 'dictionary.businessClient',
    defaultMessage: 'Business Client'
  },
  [FEATURES.BUSINESS_CUSTOMER]: {
    id: 'dictionary.businessCustomer',
    defaultMessage: 'Business Customer'
  },
  [FEATURES.PARTNER]: {
    id: 'dictionary.partner',
    defaultMessage: 'Partner'
  },
  [FEATURES.PARTNERS_PAYMENT_SUMMARY]: {
    id: 'dictionary.partnersPaymentSummary',
    defaultMessage: 'Partners Payment Summary'
  },
  [FEATURES.CORPORATE_KREDITS]: {
    id: 'dictionary.corporateKredits',
    defaultMessage: 'Corporate Kredits'
  },
  [FEATURES.PARTNER_COST]: {
    id: 'dictionary.partnerCost',
    defaultMessage: 'Partner Cost'
  },
  [FEATURES.OPERATIONAL_COSTS]: {
    id: 'dictionary.operationalCosts',
    defaultMessage: 'Operational Costs'
  },
  [FEATURES.BUSINESS_CLIENT_USER]: {
    id: 'dictionary.businessClientUser',
    defaultMessage: 'Business Client User'
  },
  [FEATURES.ROUTING_PROJECT]: {
    id: 'dictionary.routingProject',
    defaultMessage: 'Routing Project'
  }
})

export const permissionMessages: Record<string, { id: string; defaultMessage: string }> = defineMessages({
  [PERMISSIONS.ALL_ACCESS]: {
    id: 'dictionary.allAcess',
    defaultMessage: 'All access'
  },
  [PERMISSIONS.READ]: {
    id: 'dictionary.read',
    defaultMessage: 'Read'
  },
  [PERMISSIONS.ON_SITE]: {
    id: 'dictionary.onSite',
    defaultMessage: 'On site'
  },
  [PERMISSIONS.CANCEL]: {
    id: 'dictionary.cancel',
    defaultMessage: 'Cancel'
  },
  [PERMISSIONS.BOARDING]: {
    id: 'dictionary.boarding',
    defaultMessage: 'Boarding'
  },
  [PERMISSIONS.BOOKINGS_READ]: {
    id: 'dictionary.bookingsRead',
    defaultMessage: 'Download bookings'
  },
  [PERMISSIONS.DEMAND_READ]: {
    id: 'dictionary.demandRead',
    defaultMessage: 'Download demands'
  },
  [PERMISSIONS.OFFER_READ]: {
    id: 'dictionary.offerRead',
    defaultMessage: 'Download offers'
  },
  [PERMISSIONS.USERS_READ]: {
    id: 'dictionary.usersRead',
    defaultMessage: 'Download users'
  },
  [PERMISSIONS.COMPETITOR_READ]: {
    id: 'dictionary.competitorRead',
    defaultMessage: 'Download competitors'
  },
  [PERMISSIONS.TICKETS_READ]: {
    id: 'dictionary.ticketRead',
    defaultMessage: 'Download tickets'
  },
  [PERMISSIONS.OCCUPANCY_READ]: {
    id: 'dictionary.occupancyRead',
    defaultMessage: 'Download occupancy'
  },
  [PERMISSIONS.BUSINESS_BOOKINGS_READ]: {
    id: 'dictionary.businessBookingsRead',
    defaultMessage: 'Download business bookings'
  },
  [PERMISSIONS.SCHEDULE_COMMAND]: {
    id: 'dictionary.scheduleCommand',
    defaultMessage: 'Schedule command'
  },
  [PERMISSIONS.CHANGE_SCHEDULED_COMMAND]: {
    id: 'dictionary.changeScheduledCommand',
    defaultMessage: 'Change scheduled command'
  },
  [PERMISSIONS.CANCEL_SCHEDULED_COMMAND]: {
    id: 'dictionary.cancelScheduledCommand',
    defaultMessage: 'Cancel scheduled command'
  },
  [PERMISSIONS.DRAWER_BOOKINGS_READ]: {
    id: 'dictionary.drawerBookingsRead',
    defaultMessage: 'See drawer bookings'
  },
  [PERMISSIONS.DRAWER_SALES_READ]: {
    id: 'dictionary.drawerSalesRead',
    defaultMessage: 'See drawer sales'
  },
  [PERMISSIONS.DRAWER_KREDIT_SALES_READ]: {
    id: 'dictionary.drawerKreditSalesRead',
    defaultMessage: 'See drawer kredit sales'
  },
  [PERMISSIONS.EDIT]: {
    id: 'dictionary.edit',
    defaultMessage: 'Edit'
  },
  [PERMISSIONS.BOOKINGS_DASHBOARD_READ]: {
    id: 'permissions.dashboard.bookingsRead',
    defaultMessage: 'See bookings dashboard'
  },
  [PERMISSIONS.SALES_READ]: {
    id: 'permissions.dashboard.salesRead',
    defaultMessage: 'Download sales'
  },
  [PERMISSIONS.ACTIVATE]: {
    id: 'dictionary.activate',
    defaultMessage: 'Activate'
  },
  [PERMISSIONS.DEACTIVATE]: {
    id: 'dictionary.deactivate',
    defaultMessage: 'Deactivate'
  },
  [PERMISSIONS.MOVE_TRIP]: {
    id: 'permissions.moveTrip',
    defaultMessage: 'Move booking'
  },
  [PERMISSIONS.COMPANY_INSURANCE_SETTINGS_READ]: {
    id: 'permissions.insuranceSettingsRead',
    defaultMessage: 'See insurance settings'
  },
  [PERMISSIONS.CHANGE_SETTINGS]: {
    id: 'permissions.changeSettings',
    defaultMessage: 'Edit settings'
  },
  [PERMISSIONS.WASTE]: {
    id: 'permissions.waste',
    defaultMessage: 'Waste'
  },
  [PERMISSIONS.LATE_CHECKOUT_BOOKING_TICKET]: {
    id: 'permissions.lateCheckOutBookingTicket',
    defaultMessage: 'Late checkout'
  },
  [PERMISSIONS.SEND_EMAIL_BOOKING]: {
    id: 'permissions.sendEmailBooking',
    defaultMessage: 'Send email booking'
  },
  [PERMISSIONS.APPLY_TICKETS_INSURANCE]: {
    id: 'permissions.applyTicketsInsurance',
    defaultMessage: 'Apply insurance'
  },
  [PERMISSIONS.CANCEL_TICKETS_INSURANCE]: {
    id: 'permissions.cancelTicketsInsurance',
    defaultMessage: 'Cancel insurance'
  },
  [PERMISSIONS.REGISTER_BOOKING_SUPPORT_INTERACTION]: {
    id: 'permissions.registerBookingSupportInteraction',
    defaultMessage: 'Notes'
  },
  [`${FEATURES.BOOKING}:${PERMISSIONS.EDIT}`]: {
    id: 'permissions.editBooking',
    defaultMessage: 'Edit booking'
  },
  [PERMISSIONS.CONFIRM_BOOKING_PAYMENT_FROM_ADMIN]: {
    id: 'permissions.confirmBookingPayment',
    defaultMessage: 'Confirm booking payment'
  },
  [PERMISSIONS.CHANGE_TRIP_USER_IDS]: {
    id: 'permissions.changeTripUserIDs',
    defaultMessage: 'Change crew users'
  },
  [PERMISSIONS.TOGGLE_SALE_ACTIVATION]: {
    id: 'permissions.toggleSaleActivation',
    defaultMessage: 'Activate / Deactivate Sale'
  },
  [PERMISSIONS.TOGGLE_ACTIVACTION]: {
    id: 'permissions.toggleActivation',
    defaultMessage: 'Activate / Deactivate'
  },
  [PERMISSIONS.RESEND_COUPONS]: {
    id: 'permissions.resendCoupons',
    defaultMessage: 'Resend coupons'
  },
  [PERMISSIONS.CREATE_TRIP]: {
    id: 'permissions.createTrip',
    defaultMessage: 'Create trip'
  },
  [PERMISSIONS.DEACTIVATE_CAMPAIGN_SUBCAMPAIGN_COUPON]: {
    id: 'permissions.deactivateSubcampaignCoupon',
    defaultMessage: 'Deactivate subcampaign coupon'
  },
  [PERMISSIONS.RESEND_COUPON]: {
    id: 'permissions.resendCoupon',
    defaultMessage: 'Resend coupon'
  },
  [PERMISSIONS.INCIDENCE_SUBCAMPAIGNS_READ]: {
    id: 'permissions.incidenceSubcampaignsRead',
    defaultMessage: 'Read incidence subcampaigns'
  },
  [PERMISSIONS.DB_SUBCAMPAIGNS_READ]: {
    id: 'permissions.dbSubcampaignsRead',
    defaultMessage: 'Read database subcampaigns'
  },
  [PERMISSIONS.CREATE_SUBCAMPAIGN]: {
    id: 'permissions.createSubcampaign',
    defaultMessage: 'Create subcampaign'
  },
  [PERMISSIONS.DEPOSIT_KREDIT_CORPORATE_FUNDS_FROM_ADMIN]: {
    id: 'permissions.depositKreditCorporateFundsFromAdmin',
    defaultMessage: 'Deposit kredit corporate funds'
  },
  [PERMISSIONS.CHANGE_CONFIRMATION_MODALITIES]: {
    id: 'permissions.changeConfirmationModalities',
    defaultMessage: 'Change confirmation modalities'
  },
  [PERMISSIONS.REGISTER_BOOKING_TAX_INVOICED_FROM_ADMIN]: {
    id: 'permissions.registerBookingTaxInvoicedFromAdmin',
    defaultMessage: 'Register booking tax invoiced'
  },
  [PERMISSIONS.CHANGE_DRIVER]: {
    id: 'permissions.changeDriver',
    defaultMessage: 'Change driver'
  },
  [PERMISSIONS.CHANGE_ITINERARY]: {
    id: 'permissions.changeItinerary',
    defaultMessage: 'Change itinerary'
  },
  [PERMISSIONS.CHANGE_PAST_VEHICLE]: {
    id: 'permissions.changePastVehicle',
    defaultMessage: 'Change past vehicle'
  },
  [PERMISSIONS.CHANGE_ROUTE]: {
    id: 'permissions.changeRoute',
    defaultMessage: 'Change route'
  },
  [PERMISSIONS.CHANGE_VEHICLE]: {
    id: 'permissions.changeVehicle',
    defaultMessage: 'Change vehicle'
  },
  [PERMISSIONS.ASSIGN_PRICE]: {
    id: 'permissions.assignPrice',
    defaultMessage: 'Assign price'
  }
})
